module.exports = __webpack_public_path__ + "img/ah-icon-question-outline.c436de78.svg";